import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardHeader,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import firebase from '../../Firebase';
import 'firebase/database';
import { SIREN_COLOR, SIREN_BOARD_ITEM_HEIGHT, SIREN_BOARD_TITLE_HEIGHT, CONFIG_SETTINGS } from "config.js";
import palette from 'theme/palette';
import audioFile from './../../assets/sounds/AlarmClock.mp3';
import {useSelector} from 'react-redux';
import { useIntl } from "react-intl";


/**
 * 긴급
 *  - 낙상 발행: calling
 * @param {*} props 
 * @returns 
 */
const EmergencyBoard = props => {
  const {className, ...rest} = props;

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [emergencyTarget, setEmergencyTarget] = useState();
  const [emergencyClear, setEmergencyClear] = useState();

  const [audio, setAudio] = useState( new Audio(audioFile) );
  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)

  const datas = [
    {
      label: formatMessage({id:'emergency_target'}),
      value: emergencyTarget,
    },
    {
      label: formatMessage({id:'emergency_clear'}),
      value: emergencyClear,
    },
  ];



  var i = 0;
  let intervalID = 0;
  let playIntervalID = 0;

  const flash = () =>  {
    document.body.style.backgroundColor = (i = ~i) ? '#FF0000': '#FFFF00';
  }


  var trackLength = 8000;
  var playthroughs = 100; // play max 100 times

  const playaudio = () => {
    if(playthroughs > 0){
      audio.pause();
      audio.currentTime = 0;//play stop

      audio.muted = true;
      audio.play();

      audio.muted = false;
      playthroughs--;
      console.log("playthroughs : ", playthroughs);
    } else {
      playthroughs = 100;
      clearInterval(playIntervalID);
    }

    if (localStorage.getItem(CONFIG_SETTINGS.PLAY_EMERGENCY_ALARM) == 'false'){
        stopAlarm();
        return;
      }
  }



  const stopAlarm = () => {
    console.log("stopAlarm - Emergency");
    clearInterval( intervalID );
    intervalID = 0;
    document.body.style.backgroundColor = palette.background.default;

    clearInterval(playIntervalID);
    playIntervalID = 0;

    playthroughs = 100;
    audio.currentTime = 0;//play stop
    audio.pause();
  }


  useEffect(() => {

    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    //NOTE: 긴급 알람은 "긴급"탭의 "긴급대상"이 1이상일 때, 소리 발생함.
    var dbRef = firebase.database().ref('/dashboard/'+ firebaseRootRef ).child("dashboard").child("emergency");

    dbRef.on('value', function(snapshot) {
      snapshot.forEach(function(childSnapshot){

        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();

        if(childKey === "target"){
          setEmergencyTarget(childData);

          if (intervalID > 0) {
            stopAlarm();
          }

          if(childData >= 1){

            localStorage.setItem(CONFIG_SETTINGS.PLAY_EMERGENCY_ALARM, true);

            intervalID = setInterval(flash, 2000);
            playIntervalID = setInterval(playaudio, trackLength);
          }
        }
        else if (childKey === "clear"){
          setEmergencyClear(childData);
        }

      });
    });
  }, []);



  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
      >

      <CardHeader
        className={classes.title}
        title={formatMessage({id:'emergency_board_title'})}
        titleTypographyProps={{ color: 'inherit',  variant:'h6'}}
      />


      <List>
        {datas.map((data) => (
          <ListItem classes={{ divider: classes.itemDivider}}
            divider
            key={data.label}>

            <ListItemText primary={data.label}
              primaryTypographyProps={{ color: 'textSecondary', variant: 'body1' }}/>
            <Typography color="inherit" variant="h5">{data.value}</Typography>
          </ListItem>
        ))}
      </List>

    </Card>
  );
};


EmergencyBoard.propTypes = {
  className: PropTypes.string
};

export default EmergencyBoard;

const useStyles = makeStyles((theme) => ({

  root:{
  },
  title: {
    color: theme.palette.primary.contrastText,
    backgroundColor: SIREN_COLOR.EMERGENCY_BG2_COLOR,
    height:SIREN_BOARD_TITLE_HEIGHT,
    padding: '8px 14px',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  itemDivider: {
    height:SIREN_BOARD_ITEM_HEIGHT
  }
}));
